import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import ChapterService from "./chapterService";


export const getChapters = createAsyncThunk("Chapter/get-Chapters", async (token,thunkAPI) => {
  try {
    return await ChapterService.getChapters(token);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
}); 
export const createChapter = createAsyncThunk(
  "Chapter/create-Chapters",
  async (AssociationData, thunkAPI) => {
    try {
      return await ChapterService.createChapter(AssociationData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const getChapter = createAsyncThunk(
  "Chapter/get-Chapter",
  async (id, thunkAPI) => {
    try {
      return await ChapterService.getChapter(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const updateChapter = createAsyncThunk(
  "Chapter/update-Chapter",
  async (id, thunkAPI) => {
    try {
      return await ChapterService.updateChapter(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const deleteChapter = createAsyncThunk(
  "Chapter/delete-Chapter",
  async (id, thunkAPI) => {
    try {
      return await ChapterService.deleteChapter(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const resetState = createAction("Reset_all");

const initialState = {
  Chapters: [],
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
};
export const AssociationSlice = createSlice({
  name: "Chapter",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getChapters.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getChapters.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.Chapters = action.payload.data;
      })
      .addCase(getChapters.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(createChapter.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createChapter.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.createdChapter = action.payload;
      })
      .addCase(createChapter.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.payload;
      })

      .addCase(getChapter.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getChapter.fulfilled, (state, action) => {
        state.isLoading = false; 
        state.isError = false;
        state.isSuccess = true;
        state.chaptersname= action.payload.data.name;
        state.chapterspost= action.payload.data.post;
        state.chaptersemail= action.payload.data.email;
        state.chaptersphone= action.payload.data.phone;
        state.chapterslocation= action.payload.data.location;
      })
      .addCase(getChapter.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(updateChapter.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateChapter.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.updatedChapter = action.payload;
      })
      .addCase(updateChapter.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(deleteChapter.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteChapter.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.deletedChapter = action.payload;
      })
      .addCase(deleteChapter.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(resetState, () => initialState);
  },
});
export default AssociationSlice.reducer;
